import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';
import history from './browserHistory';

// Shared by both sidebars: `due` = my open tasks due today or overdue, `inbox` = unread task notifications.
// Pass enabled=false to skip every request (e.g. the user cannot see the Tasks entry).
const useTaskBadges = (enabled = true) => {
  const [taskBadges, setTaskBadges] = useState({ inbox: 0, due: 0 });

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const versions = { due: 0, inbox: 0 };
    const refresh = () => {
      const load = (key, url, params, read) => {
        const version = ++versions[key];
        axios.get(`${config.API_URL}${url}`, { params }).then(response => {
          if (!active || version !== versions[key]) return;
          const value = read(response.data);
          if (Number.isFinite(value)) setTaskBadges(prev => ({ ...prev, [key]: value }));
        }).catch(() => {});
      };
      // The badge shows the user's own open tasks that are due today or overdue (counts.today, on-hold excluded).
      load('due', '/tasks', { segment: 'today', assignee: 'mine' }, data => data?.counts?.today);
      load('inbox', '/task-notifications', { filter: 'unread' }, data => data?.unread_count);
    };
    const handleBadges = event => {
      if (!active) return;
      const updates = {};
      for (const key of ['due', 'inbox']) {
        if (!Number.isFinite(event.detail?.[key])) continue;
        // A current list result must win over an older sidebar request.
        versions[key]++;
        updates[key] = event.detail[key];
      }
      setTaskBadges(prev => ({ ...prev, ...updates }));
    };
    window.addEventListener('coms-task-badges', handleBadges);
    window.addEventListener('focus', refresh);
    const unlisten = history.listen(refresh);
    refresh();
    return () => {
      active = false;
      window.removeEventListener('coms-task-badges', handleBadges);
      window.removeEventListener('focus', refresh);
      unlisten();
    };
  }, [enabled]);

  return taskBadges;
};

export default useTaskBadges;
